import BarGraphs from "../../components/ClassTwo/NumberMath/BarGraphs";
import LineCharts from "../../components/ClassTwo/NumberMath/LineCharts";
import Pictographs from "../../components/ClassTwo/NumberMath/Pictographs";
import PieCharts from "../../components/ClassTwo/NumberMath/PieCharts";
import Tables from "../../components/ClassTwo/NumberMath/Tables";
import TallyMarks from "../../components/ClassTwo/NumberMath/TallyMarks";


// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/number-math/data-handling-tally-marks", title: "Tally Marks", component: TallyMarks },
    { url: "/class-two/number-math/data-handling-pictographs", title: "Pictographs", component: Pictographs },
    { url: "/class-two/number-math/data-handling-bar-graphs", title: "Bar Graphs", component: BarGraphs },
    { url: "/class-two/number-math/data-handling-tables", title: "Tables", component: Tables },
    { url: "/class-two/number-math/data-handling-pie-charts", title: "Pie Charts", component: PieCharts },
    { url: "/class-two/number-math/data-handling-line-graphs", title: "Line Graphs", component: LineCharts }
];

export default topics;